const unidades = {
  AAC: ["pieza", "largo", "semip", "factor"],
  KG: ["pieza", "alto", "largo"],
  lote: ["pieza"],
  LOTE: ["pieza"],
  pieza: ["pieza"],
  PZA: ["pieza"],
  JOR: ["pieza"],
  VJE: ["pieza"],
  SAL: ["pieza"],
  PDA: ["pieza"],
  MOD: ["pieza"],
  KM: ["pieza"],
  RENTA: ["pieza"],
  EVENTO: ["pieza"],
  UND: ["pieza"],
  ML: ["pieza", "largo"],
  FT2: ["pieza", "alto", "largo"],
  M2: ["pieza", "alto", "largo"],
  M3: ["pieza", "alto", "largo", "ancho"],
};

export const isAirConditioner = (concepto) => String(concepto?.clave).includes("AAC") && ["KG", "FT2"].includes(concepto?.unidad);

// Measurement columns are grouped by the author's role: Contratista (solicitado),
// Supervisor (supervisado) and Obras (autorizado).
export const DEFAULT_TYPE_SOLICITADO = 6;
export const DEFAULT_TYPE_SUPERVISADO = 3;
export const DEFAULT_TYPE_AUTORIZADO = 5;
export const REQUIRED_DEFAULT_TYPES = [
  DEFAULT_TYPE_SOLICITADO,
  DEFAULT_TYPE_SUPERVISADO,
  DEFAULT_TYPE_AUTORIZADO,
];

// Map any medición author to one of the three recognized column groups. Only
// Supervisor(3) and Obras(5) are explicit; every other role — including admins
// who upload the generador — is treated as Contratista/solicitado(6). This keeps
// uploaded measurements in the Contratista column (and its total) instead of
// spilling into a stray extra group that breaks the table alignment.
export const getEffectiveDefaultType = (defaultType) =>
  defaultType === DEFAULT_TYPE_SUPERVISADO ||
  defaultType === DEFAULT_TYPE_AUTORIZADO
    ? defaultType
    : DEFAULT_TYPE_SOLICITADO;

export const getConceptosKeys = (concepto) => {
  let keys = unidades[concepto.unidad] ? unidades[concepto.unidad] : ["lote"];
  if (isAirConditioner(concepto)) {
    keys = unidades.AAC;
  }
  return keys;
};

export const getSumConcepto = (concepto) => {
  let keys = getConceptosKeys(concepto);
  if (isAirConditioner(concepto)) {
    keys = keys.filter(key => key !== "semip");
  }
  let total = 1.0;
  keys.forEach((key) => {
    total *= parseFloat(concepto[key]);
  });
  if (isAirConditioner(concepto)) {
    total *= 1.07;
    if (String(concepto.unidad) === "FT2") {
      total *= 10.77;
    }
  }
  return total;
};

export function getTipo(concepto) {
  if (concepto.extra) return "Extra";
  if (concepto.acumulado_importe_autorizado && concepto.acumulado_importe_autorizado !== null) {
    return concepto.acumulado_importe_autorizado > concepto.importe
      ? "aditivo"
      : "normal";
  }
  if (concepto.autorizado && concepto.autorizado !== null) {
    if (
      parseFloat(concepto.autorizado) > parseFloat(concepto.cantidad) ||
      parseFloat(concepto.autorizadoActual) + parseFloat(concepto.autorizado) >
        parseFloat(concepto.cantidad)
    ) {
      return "aditivo";
    }
  }
  if (concepto.supervisado && concepto.supervisado !== null) {
    return concepto.supervisado > concepto.cantidad ? "aditivo" : "normal";
  }
  if (concepto.estimado && concepto.estimado !== null) {
    return concepto.estimado > concepto.cantidad ? "aditivo" : "normal";
  }
  return "Normal";
}

export const getConceptoEstimacionData = (conceptosEstimacion, conceptos) => {
  conceptosEstimacion = conceptosEstimacion.map((concepto) => {
    let conceptoEstimado = conceptos.find(
      (conceptoEst) =>
        parseInt(conceptoEst.idConcepto) === parseInt(concepto.idConcepto)
    );
    concepto = {
      ...concepto,
      estimadoAnterior:
        concepto.estimado !== null && concepto.estimadoAcumulado !== null
          ? parseFloat(concepto.estimadoAcumulado) -
            parseFloat(concepto.estimado)
          : concepto.estimado !== null
          ? concepto.estimado
          : 0,
      autorizadoAnterior:
        concepto.autorizado !== null && concepto.autorizadoAcumulado !== null
          ? parseFloat(concepto.autorizadoAcumulado) -
            parseFloat(concepto.autorizado)
          : concepto.autorizado !== null
          ? concepto.autorizado
          : 0,
      supervisadoAnterior:
        concepto.supervisado !== null && concepto.supervisadoAcumulado !== null
          ? parseFloat(concepto.supervisadoAcumulado) -
            parseFloat(concepto.supervisado)
          : concepto.supervisado !== null
          ? concepto.supervisado
          : 0,
      importeAnterior:
        concepto.importe_autorizado !== null ? concepto.importe_autorizado : 0,
    };
    if (conceptoEstimado) {
      concepto = {
        ...concepto,
        ...conceptoEstimado,
      };
    } else {
      concepto = {
        ...concepto,
        estimado: 0,
        autorizado: 0,
        supervisado: 0,
      };
    }
    if (!concepto.precio_autorizado || concepto.precio_autorizado === null) {
      if (conceptoEstimado) {
        if (
          conceptoEstimado.precio_autorizado &&
          conceptoEstimado.precio_autorizado !== null
        ) {
          concepto.precio_autorizado = conceptoEstimado.precio_autorizado;
        } else {
          concepto.precio_autorizado = concepto.precio;
        }
      } else {
        concepto.precio_autorizado = concepto.precio;
      }
    }

    // if (concepto.subconceptos.length > 0) {
    //   const subconceptosData = concepto.subconceptos.map((obj) => {
    //     getConceptoEstimacionData();
    //   });
    // }

    return concepto;
  });
};
